import { styled } from 'styled-components';

export const SaveModalContent = styled.div`
  width: 25vw;

  p {
    font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
    line-height: 1.4285;
  }
`;
SaveModalContent.displayName = 'SaveModalContent';

export const SaveStatusMessage = styled.span`
  position: absolute;
  font-size: ${({ theme }) => theme.typography.bodySmall.fontSize};
  bottom: -24px;
  color: ${({ theme }) => theme.colours.ink.primary.main};
  font-size: ${({ theme }) => theme.typography.bodySmall.fontSize};
`;
SaveStatusMessage.displayName = 'SaveStatusMessage';

export const SaveModalDropdown = styled.div`
  > div > div > div > div {
    padding: 0 ${({ theme }) => theme.sizing.small} 0 0;
  }
`;
SaveModalDropdown.displayName = 'SaveModalDropdown';

export const SaveModalValidation = styled.div`
  color: ${({ theme }) => theme.colours.messaging.error.main};
  font-size: ${({ theme }) => theme.typography.bodySmall.fontSize};
  padding: ${({ theme }) => theme.sizing.small}
    ${({ theme }) => theme.sizing.tiny} 0;
`;
SaveModalValidation.displayName = 'SaveModalValidation';

export const SaveModalValidationHeight = styled.div`
  height: 24px;
`;
SaveModalValidationHeight.displayName = 'SaveModalValidationHeight';
